import { useMutation, useQuery } from '@tanstack/react-query';
import { maasApi } from '@/api/maas.api';

/** 用 API Key 探测 MaaS 平台可用模型（创建凭证时使用）。 */
export function useProbeMaasModels() {
  return useMutation({
    mutationFn: (apiKey: string) => maasApi.listAvailableModels(apiKey),
  });
}

/** 加载已有凭证可见模型（编辑场景）。 */
export function useMaasCredentialModels(credentialId: string | undefined) {
  return useQuery({
    queryKey: ['maas-credentials', 'models', credentialId],
    queryFn: () => maasApi.listModelsByCredential(credentialId!),
    enabled: !!credentialId,
    staleTime: 30 * 1000,
  });
}

/** 连通性测试：后端暂未提供专用接口，借用 listModelsByCredential 近似实现。
 *  成功返回耗时 + 模型数；失败抛出错误，由调用方 try/catch。
 */
export function useTestMaasCredential() {
  return useMutation({
    mutationFn: async (id: string) => {
      const start = performance.now();
      const res = await maasApi.listModelsByCredential(id);
      const latencyMs = Math.round(performance.now() - start);
      return { latencyMs, modelCount: res.items.length };
    },
  });
}
